import React, { useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

export default function AttendanceSalaryDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  // Redirect to the new admin component
  useEffect(() => {
    navigate(`/admin/staff/${id}/attendance-salary`, { 
      state: location.state,
      replace: true 
    });
  }, [navigate, id, location.state]);

  return null;
}
